import FontAwesome from 'react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import Select from 'react-select';

import { entity as schoolYearsDuck } from '../../ducks/schoolYears';
import { entity as checklistItemsDuck } from '../../ducks/checklistItems';
import * as bulkFileUploader from '../../ducks/bulkFileUploader';

import ValidationErrors from '../forms/ValidationErrors';

import './styles/bulkFileWorkflowCreateModal.scss';

import { duckify, filterDuck } from '../../utils/duckify';
import SaPropTypes from 'propTypes';

const checklistItemsByYear = (schoolYear) => (item) => {
  if (!schoolYear) {
    return false;
  }

  // item with no start year is available in all years
  if (!item.start_year) {
    return true;
  }

  // If there is a start year, our selected year must be after it.
  if (item.start_year.start_year <= schoolYear.start_year){
    // Items with no end year are available in all years after the start year
    if (!item.end_year) {
      return true;
    }

    if (item.end_year.start_year >= schoolYear.start_year){
      return true;
    }
  }

  return false;
};

class BulkFileWorkflowCreateModal extends React.Component{
  static propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    createErrors: PropTypes.object,
    checklistItemId: PropTypes.string,
    checklistItems: PropTypes.arrayOf(PropTypes.object),
    handleSubmit: PropTypes.func,
    file: PropTypes.shape({
      name: PropTypes.string
    }),
    onClose: PropTypes.func.isRequired,
    schoolYearId: PropTypes.string,
    schoolYears: PropTypes.arrayOf(SaPropTypes.SchoolYear),
    setInputs: PropTypes.func,
    show: PropTypes.func,
    submitting: PropTypes.bool
  };

  static defaultProps = {
    createErrors: null,
    checklistItemId: '',
    checklistItems: [],
    file: {},
    schoolYearId: '',
    schoolYears: [],
    handleSubmit: () => false,
    setInputs: () => false,
    show: () => false,
    submitting: false
  };

  componentDidMount() {
    const { show } = this.props;

    show();
  }

  submit() {
    const { handleSubmit } = this.props;
    const {
      schoolYearId: school_year_id,
      checklistItemId: checklist_item_id,
      file
    } = this.state;

    return handleSubmit({ school_year_id, checklist_item_id, file });
  }

  render() {
    const {
      checklistItemId,
      checklistItems,
      createErrors,
      file,
      handleSubmit,
      onClose,
      schoolYearId,
      schoolYears,
      setInputs,
      submitting
    } = this.props;

    const schoolYear = schoolYears.find((year) => year.id === schoolYearId);
    const filteredChecklistItems = checklistItems.filter(checklistItemsByYear(schoolYear));

    // HACK to make dropzone testable
    window.dropBulkFileUploadFiles = (files) => setInputs({ file: files[0] });

    return (
      <Modal show backdrop='static' keyboard={false} className="bulk-file-workflow-create-modal modal">
        <Modal.Header>
          <h1 className='modal-title' style={{ display: 'inline-block' }}>Bulk File Upload</h1>
          <button type="button" className="btn-close" aria-label="Close" onClick={() => onClose()} />
        </Modal.Header>
        <Modal.Body style={{ overflow: 'visible' }}>
          {createErrors &&
            <ValidationErrors errors={createErrors}
              fieldNames={{
                file: 'File',
                file_content_type: 'File Content Type',
                school_year_id: 'School Year',
                school_year: 'School Year',
                checklist_item_id: 'Checklist Item',
                checklist_item: 'Checklist Item'
              }} />
          }

          <p>
            Please select a checklist item and upload scanned images.
            We support multi-page PDFs or ZIPs containing multiple images.
          </p>

          <div className="mb-3 school-year-input">
            <label className="col-form-label">Term</label>
            <div className="controls">
              <Select
                options={schoolYears.map((year) => ({
                  value: year.id,
                  label: year.name
                }))}
                onChange={({ value }) => setInputs({ schoolYearId: value })}
                value={schoolYearId}
                disabled={!!submitting}
                placeholder="Please Select a Term..."
              />
            </div>
          </div>


          <div className="mb-3 checklist-item-input">
            <label className="col-form-label">Checklist Item</label>
            <div className="controls">
              <Select
                options={filteredChecklistItems.map((item) => ({
                  value: item.id,
                  label: item.name
                }))}
                onChange={({ value }) => setInputs({ checklistItemId: value })}
                value={checklistItemId}
                disabled={!!submitting}
                placeholder={filteredChecklistItems.length ? "Please Select a Checklist Item..." : "There are no checklist items for this term"}
              />
            </div>
          </div>

          <Dropzone className={`bulk-file-upload-dropzone text-center ${file ? 'completed' : 'pending'}`}
            onDrop={(files) => setInputs({ file: files[0] })}
            disabled={!!submitting}
            multiple={false}>
            <div className="upload-icon">
              {!!file ? <FontAwesome name="file-o" /> : <FontAwesome name="cloud-upload" />}
            </div>
            {!!file ?
              <div className="upload-details">{file.name}</div> :
              <div className="upload-details">Drag and drop a file here, or click to select from your file system</div>
            }
          </Dropzone>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='light' onClick={() => onClose()}>Cancel</Button>
          <Button variant="primary" type="submit"
            onClick={() => handleSubmit({ schoolYearId, checklistItemId, file })}
            disabled={!!submitting || !schoolYearId || !checklistItemId || !file}>
            {submitting && <FontAwesome name="spinner" spin />}
            {submitting ? " Submitting" : "Submit"}
          </Button>
        </Modal.Footer>

      </Modal>
  )}
}

const mapStateToProps = (state) => state.bulkFileUploader.createModal;

const mapDispatchToProps = (dispatch) => ({
  setInputs: (inputs) => dispatch(bulkFileUploader.actions.setCreateModalProps(inputs)),
  handleSubmit: ({schoolYearId, checklistItemId, file}) => dispatch(bulkFileUploader.actions.createWorkflow({
    school_year_id: schoolYearId,
    checklist_item_id: checklistItemId,
    file
  })),
  show: () => dispatch(bulkFileUploader.actions.showCreateModal())
});

const mapDucksToProps = () => ({
  schoolYears: schoolYearsDuck,
  checklistItems: filterDuck(checklistItemsDuck, {
    item_type: 'file_upload'
  })
});

export default duckify(mapDucksToProps, mapStateToProps, mapDispatchToProps)(BulkFileWorkflowCreateModal);
